/* NB Variant Collection (sections/nb-variant-collection.liquid).
   Carousel prev/next for each <nb-variant-collection>, plus, on product pages,
   re-rendering the section through the Section Rendering API whenever the PDP
   variant changes so the carousel follows the variant's Variant Collection entry.
   The fetched element replaces this one, so everything re-initializes through
   connectedCallback. */
if (!customElements.get('nb-variant-collection')) {
  customElements.define(
    'nb-variant-collection',
    class NbVariantCollection extends HTMLElement {
      connectedCallback() {
        this.initCarousels();
        // Cards swapped in by a re-render need their quick-add popovers bound;
        // on first paint nb-quick-add.js has already done this (it guards).
        if (typeof window.nbQuickAddBind === 'function') window.nbQuickAddBind(this);

        this.variantCollections = this.parseVariantCollections();
        if (this.variantCollections && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();
        this.unsubscribeVariantChange = null;
        this.abortController?.abort();
      }

      /* ---------- variant → Variant Collection entry ---------- */

      // { "<variant id>": "<metaobject entry handle or ''>" } for every variant of the
      // page's product ('' = no entry/collection, section hidden). Absent outside product pages.
      parseVariantCollections() {
        const raw = this.dataset.variantCollections;
        if (!raw || !this.dataset.productUrl || !this.dataset.sectionId) return null;
        try {
          return JSON.parse(raw);
        } catch (error) {
          console.error('[nb-variant-collection] invalid data-variant-collections:', error);
          return null;
        }
      }

      onVariantChange(event) {
        const variant = event?.data?.variant;
        if (!variant) return;

        const key = String(variant.id);
        // Not one of this product's variants (e.g. a quick-add modal on the same page).
        if (!Object.prototype.hasOwnProperty.call(this.variantCollections, key)) return;

        const nextHandle = this.variantCollections[key] || '';
        const currentHandle = this.dataset.entry || '';
        if (nextHandle === currentHandle) return;

        this.renderForVariant(variant.id);
      }

      renderForVariant(variantId) {
        this.abortController?.abort();
        const controller = new AbortController();
        this.abortController = controller;

        const url = `${this.dataset.productUrl}?variant=${variantId}&section_id=${this.dataset.sectionId}`;
        this.setAttribute('aria-busy', 'true');

        fetch(url, { signal: controller.signal })
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const fresh = html.querySelector('nb-variant-collection');
            if (!fresh) throw new Error('response did not contain <nb-variant-collection>');
            // Adopting the node into this document upgrades it and runs connectedCallback.
            this.replaceWith(fresh);
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            console.error('[nb-variant-collection] failed to render section for variant:', error);
          })
          .finally(() => {
            if (this.abortController === controller) {
              this.abortController = null;
              this.removeAttribute('aria-busy');
            }
          });
      }

      /* ---------- carousel ---------- */

      initCarousels() {
        this.querySelectorAll('[js-carousel-track]').forEach((track) => {
          const carousel = track.closest('.nb-collections-carousel');
          const prev = carousel.querySelector('[js-prev]');
          const next = carousel.querySelector('[js-next]');
          const slide = track.querySelector('.nb-carousel-slide');

          const updateNavButtons = () => {
            prev.disabled = track.scrollLeft <= 0;
            next.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 1;
          };

          const scrollBy = (direction) => {
            const distance = slide ? slide.offsetWidth + 24 : 320;
            track.scrollBy({ left: direction * distance, behavior: 'smooth' });
          };

          prev.addEventListener('click', () => scrollBy(-1));
          next.addEventListener('click', () => scrollBy(1));
          track.addEventListener('scroll', updateNavButtons, { passive: true });
          updateNavButtons();
        });
      }
    }
  );
}
